import './style.sass';

import React from 'react';
import FullWrapper from '../../../../cases/reusable-components/layouts-components__common-cases/full-wrapper';
import Link from 'next/link';
import BasicLink from '../../../../../../../core/BasicLink';

const BannerCaseNav = ({ listPath }) => {
    const lastElement = listPath[listPath.length - 1];

    return (
        <FullWrapper className="navigation">
            <div className="navigation-wrapper">
                {listPath.map((item, key) => {
                    const indexArray = listPath.findIndex(item => item.name === lastElement.name);

                    return (
                        <>
                            {item.path ? (
                                <>
                                    <BasicLink
                                        key={item.name}
                                        className="navigation-link"
                                        href={item.path}
                                    >
                                        {item.name}
                                    </BasicLink>
                                    {key === indexArray ? '' : ' / '}
                                </>
                            ) : (
                                item.name
                            )}
                        </>
                    );
                })}
            </div>
        </FullWrapper>
    );
};
export default BannerCaseNav;
